import { render, staticRenderFns } from "./AkgLiveStats.component.vue?vue&type=template&id=0be6befc&scoped=true&"
import script from "./AkgLiveStats.component.vue?vue&type=script&lang=js&"
export * from "./AkgLiveStats.component.vue?vue&type=script&lang=js&"
import style0 from "./AkgLiveStats.component.vue?vue&type=style&index=0&id=0be6befc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be6befc",
  null
  
)

export default component.exports